module.exports = __webpack_public_path__ + "fonts/SuisseIntl-BlackItalic.ae8f225.woff";